import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=1b3f5370&scoped=true"
import script from "./order-summary.vue?vue&type=script&lang=js"
export * from "./order-summary.vue?vue&type=script&lang=js"
import style0 from "./order-summary.vue?vue&type=style&index=0&id=1b3f5370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f5370",
  null
  
)

export default component.exports